import { AxiosResponse } from 'axios';
import { BaseClient } from '../client/baseClient';
import { APIResponse } from '../types';
import { apiErrorMessage } from '../utils/apiErrorMessage';

class APIService extends BaseClient {
    constructor() {
        super();
    }

    protected handleResponseError(error: any): Promise<any> {
        if (error.response?.status === 401) {
            // Handle unauthorized access
            localStorage.removeItem('auth_token');
            window.location.href = '/login';
        }
        return super.handleResponseError(error);
    }

    // Helper method to handle API responses
    private handleResponse<T>(response: AxiosResponse<APIResponse<T>>): T {
        if (response.data.success) {
            return response.data.data as T;
        } else {
            throw new Error(response.data.error || 'API request failed');
        }
    }

    // NOTE (TASK-902): 13 dead methods hitting unmounted orchestrator routes
    // (/rfqs/*, /documents/*, /users/*) were removed along with healthCheck
    // (its envelope unwrap threw even on healthy 200s). What survives here
    // moves into the TASK-1002 query-hook rebuild.

    // Places endpoints (proxied through the backend — no Google key on the client)
    async getPlaceAutocomplete(
        input: string,
        sessionToken?: string,
        regionCodes?: string[],
        types?: string[]
    ): Promise<{ predictions: Array<{ placeId: string; description: string }> }> {
        const params: Record<string, string> = { input };
        if (sessionToken) {
            params.sessiontoken = sessionToken;
        }
        if (regionCodes && regionCodes.length > 0) {
            params.regions = regionCodes.join(',');
        }
        if (types && types.length > 0) {
            params.types = types.join(',');
        }
        const response = await this.api.get('/trp/places/autocomplete', {
            params,
        });
        return this.handleResponse(response);
    }

    // Error handling helper
    getErrorMessage(error: any): string {
        return apiErrorMessage(error, 'An unexpected error occurred');
    }
}

// Create and export a singleton instance
const apiService = new APIService();
export default apiService;

// Export the class for testing purposes
export { APIService };
